<template>
  <div>
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-card class="ma-4 pa-6">
        <v-tabs v-model="activeTab" background-color="transparent" color="primary">
          <v-tab v-for="tab in tabs" :key="tab.key">
            {{ tab.label }}
          </v-tab>
        </v-tabs>

        <v-divider class="mb-4"></v-divider>

        <v-tabs-items v-model="activeTab">
          <!-- 代码管理 -->
          <v-tab-item>
            <div class="pa-4">
              <!-- 上传并生成体验版 -->
              <v-card class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold">
                  上传并生成体验版
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                  <v-container>
                    <v-row>
                      <v-col cols="3" class="font-weight-bold text-right">
                        模板ID：
                      </v-col>
                      <v-col cols="9" md="6">
                        <v-text-field
                          v-model="templateId"
                          single-line dense hide-details
                          placeholder="请输入 template_id"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mt-2">
                      <v-col cols="3" class="font-weight-bold text-right">
                        小程序AppId：
                      </v-col>
                      <v-col cols="9" md="6">
                        <v-text-field
                          v-model="extAppid"
                          single-line dense hide-details
                          placeholder="请输入 extAppid"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mt-2">
                      <v-col cols="3" class="font-weight-bold text-right">
                        品牌码：
                      </v-col>
                      <v-col cols="9" md="6">
                        <v-text-field
                          v-model="accountId"
                          single-line dense hide-details
                          placeholder="请输入 accountId"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mt-2" align="center">
                      <v-col cols="3" class="font-weight-bold text-right">
                        是否允许输入品牌码：
                      </v-col>
                      <v-col cols="9" md="6">
                        <v-radio-group
                          v-model="showAccountId"
                          row
                          dense
                          hide-details
                          hint="启用时品牌码须为空才能生效。"
                          persistent-hint
                        >
                          <v-radio
                            :value="true"
                            label="是"
                          ></v-radio>
                          <v-radio
                            :value="false"
                            label="否"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row v-if="showAccountId" class="mt-2">
                      <v-col cols="3" class="font-weight-bold text-right">
                        通用版默认品牌码：
                      </v-col>
                      <v-col cols="9" md="6">
                        <v-text-field
                          v-model="defaultAccountId"
                          single-line dense
                          hint="默认品牌码是显示对应品牌的小程序首页以及商品页。"
                          persistent-hint
                          placeholder="请输入通用版默认品牌码"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions class="px-4 pb-4">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    :loading="committing"
                    @click="handleCommit"
                  >
                    上传并提交
                  </v-btn>
                </v-card-actions>
              </v-card>

              <!-- 快捷查询 -->
              <v-card>
                <v-card-title class="subtitle-1 font-weight-bold">
                  快捷查询 — 体验版二维码
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4 text-center">
                  <v-btn
                    color="primary"
                    outlined
                    :loading="qrLoading"
                    @click="fetchQRCode"
                  >
                    获取体验版二维码
                  </v-btn>
                  <div v-if="qrImageUrl" class="mt-4">
                    <v-img
                      :src="qrImageUrl"
                      max-width="280"
                      max-height="280"
                      class="mx-auto"
                      contain
                    ></v-img>
                    <p class="mt-2 text-caption grey--text">
                      使用微信扫描二维码体验小程序
                    </p>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </v-tab-item>

          <!-- 审核发布 -->
          <v-tab-item>
            <div class="pa-4">
              <!-- 提交审核 -->
              <v-card class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold">
                  提交审核
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                  <v-container>
                    <v-row>
                      <v-col cols="3" class="font-weight-bold text-right">
                        审核参数（JSON）：
                      </v-col>
                      <v-col cols="9" md="6">
                        <v-textarea
                          v-model="auditFormJson"
                          rows="18"
                          dense
                          :error-messages="jsonErrors.audit ? [jsonErrors.audit] : []"
                          :class="jsonErrors.audit ? 'error--text' : ''"
                          outlined
                          monospace
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions class="px-4 pb-4">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    :loading="auditSubmitting"
                    @click="handleSubmitAudit"
                  >
                    提交审核
                  </v-btn>
                </v-card-actions>
              </v-card>

              <!-- 查询审核状态 -->
              <v-card class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold">
                  查询审核状态
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                  <v-container>
                    <v-row align="center">
                      <v-col cols="3" class="font-weight-bold text-right">
                        审核单ID（auditid）：
                      </v-col>
                      <v-col cols="5">
                        <v-text-field
                          v-model="auditQueryId"
                          single-line dense hide-details
                          placeholder="提交审核后返回的 auditid"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-btn
                          color="primary" outlined class="mr-2"
                          :loading="auditQueryLoading"
                          @click="handleGetAuditStatus"
                        >
                          查询指定审核单
                        </v-btn>
                        <v-btn
                          color="secondary" outlined
                          :loading="latestAuditQueryLoading"
                          @click="handleGetLatestAuditStatus"
                        >
                          查询最新审核单
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row v-if="auditQueryResult" class="mt-4">
                      <v-col cols="12">
                        <v-card outlined color="grey lighten-5">
                          <v-card-title class="py-1 px-3" style="cursor:pointer" @click="auditExpanded = !auditExpanded">
                            <span class="caption">接口返回结果</span>
                            <v-spacer></v-spacer>
                            <v-icon small>{{ auditExpanded ? 'fa-chevron-up' : 'fa-chevron-down' }}</v-icon>
                          </v-card-title>
                          <v-card-text v-show="auditExpanded">
                            <pre style="white-space:pre-wrap;word-break:break-all;margin:0;font-size:13px;">{{ auditQueryResult }}</pre>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>

              <!-- 发布 -->
              <v-card>
                <v-card-title class="subtitle-1 font-weight-bold">
                  发布小程序
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                  <p class="grey--text text--darken-1">
                    审核通过后，点击下方按钮将小程序发布上线。发布前请确认审核状态已通过。
                  </p>
                </v-card-text>
                <v-card-actions class="px-4 pb-4">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="success"
                    :loading="releasing"
                    @click="releaseDialog = true"
                  >
                    发布上线
                  </v-btn>
                </v-card-actions>
              </v-card>
            </div>
          </v-tab-item>

          <!-- 配置设置 -->
          <v-tab-item>
            <div class="pa-4">
              <!-- 费率设置 -->
              <v-card class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold">
                  费率设置（setmchprofitrate）
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                  <v-container>
                    <v-row>
                      <v-col cols="3" class="font-weight-bold text-right">
                        子商户号（sub_mchid）：
                      </v-col>
                      <v-col cols="9" md="6">
                        <v-text-field
                          v-model="rateForm.sub_mchid"
                          single-line dense hide-details
                          placeholder="请输入子商户号"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mt-2">
                      <v-col cols="3" class="font-weight-bold text-right">
                        费率（profit_rate）：
                      </v-col>
                      <v-col cols="9" md="6">
                        <v-text-field
                          v-model="rateForm.profit_rate"
                          single-line dense
                          hint="万分比，例如 40 表示 0.40%"
                          persistent-hint
                          placeholder="请输入费率（整数）"
                          type="number"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions class="px-4 pb-4">
                  <v-spacer></v-spacer>
                  <v-btn color="primary" :loading="rateSubmitting" @click="handleSetRate">
                    申请费率
                  </v-btn>
                </v-card-actions>
              </v-card>

              <!-- 域名配置 -->
              <v-card class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold">
                  域名配置（modifyDomain）
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                  <v-container>
                    <v-row>
                      <v-col cols="3" class="font-weight-bold text-right">
                        域名参数（JSON）：
                      </v-col>
                      <v-col cols="9" md="6">
                        <v-textarea
                          v-model="domainJson"
                          rows="16" dense
                          :error-messages="jsonErrors.domain ? [jsonErrors.domain] : []"
                          :class="jsonErrors.domain ? 'error--text' : ''"
                          outlined monospace
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row v-if="configQueryResult" class="mt-4">
                      <v-col cols="12">
                        <v-card outlined color="grey lighten-5">
                          <v-card-title class="py-1 px-3" style="cursor:pointer" @click="configExpanded = !configExpanded">
                            <span class="caption">接口返回结果</span>
                            <v-spacer></v-spacer>
                            <v-icon small>{{ configExpanded ? 'fa-chevron-up' : 'fa-chevron-down' }}</v-icon>
                          </v-card-title>
                          <v-card-text v-show="configExpanded">
                            <pre style="white-space:pre-wrap;word-break:break-all;margin:0;font-size:13px;">{{ configQueryResult }}</pre>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions class="px-4 pb-4">
                  <v-spacer></v-spacer>
                  <v-btn color="primary" outlined class="mr-2" :loading="domainGetLoading" @click="handleGetDomain">
                    获取当前域名
                  </v-btn>
                  <v-btn color="primary" :loading="domainSetLoading" @click="handleSetDomain">
                    配置域名
                  </v-btn>
                </v-card-actions>
              </v-card>

              <!-- 隐私协议 -->
              <v-card>
                <v-card-title class="subtitle-1 font-weight-bold">
                  隐私协议（Privacy Setting）
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                  <v-container>
                    <v-row>
                      <v-col cols="3" class="font-weight-bold text-right">
                        隐私参数（JSON）：
                      </v-col>
                      <v-col cols="9" md="6">
                        <v-textarea
                          v-model="privacyJson"
                          rows="20" dense
                          :error-messages="jsonErrors.privacy ? [jsonErrors.privacy] : []"
                          :class="jsonErrors.privacy ? 'error--text' : ''"
                          outlined monospace
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row v-if="privacyResult" class="mt-4">
                      <v-col cols="12">
                        <v-card outlined color="grey lighten-5">
                          <v-card-title class="py-1 px-3" style="cursor:pointer" @click="privacyExpanded = !privacyExpanded">
                            <span class="caption">接口返回结果</span>
                            <v-spacer></v-spacer>
                            <v-icon small>{{ privacyExpanded ? 'fa-chevron-up' : 'fa-chevron-down' }}</v-icon>
                          </v-card-title>
                          <v-card-text v-show="privacyExpanded">
                            <pre style="white-space:pre-wrap;word-break:break-all;margin:0;font-size:13px;">{{ privacyResult }}</pre>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions class="px-4 pb-4">
                  <v-spacer></v-spacer>
                  <v-btn color="primary" outlined class="mr-2" :loading="privacyGetLoading" @click="handleGetPrivacy">
                    获取隐私协议
                  </v-btn>
                  <v-btn color="primary" :loading="privacySetLoading" @click="handleSetPrivacy">
                    设置隐私协议
                  </v-btn>
                </v-card-actions>
              </v-card>

              <!-- 获取Token -->
              <v-card class="mt-6">
                <v-card-title class="subtitle-1 font-weight-bold">
                  获取Token
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4">
                  <v-btn color="primary" outlined :loading="tokenLoading" @click="handleGetToken">
                    获取token
                  </v-btn>
                  <div v-if="tokenResult" class="mt-3">
                    <v-text-field
                      :value="tokenResult"
                      readonly dense outlined monospace hide-details
                      label="AccessToken"
                    >
                      <template v-slot:append>
                        <v-btn icon small @click="copyToken">
                          <v-icon small>fa-copy</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-sheet>

    <!-- 发布确认弹窗 -->
    <v-dialog v-model="releaseDialog" max-width="400" persistent>
      <v-card>
        <v-card-title class="text-h6">确认发布</v-card-title>
        <v-card-text>确定要将小程序发布上线吗？发布后将对所有用户生效，请确保审核已通过。</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="releaseDialog = false">取消</v-btn>
          <v-btn color="success" :loading="releasing" @click="handleRelease">确认发布</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import WechatB2b from "@/api/wechat_b2b";
import Setting from "@/api/settings";
import snackbar from "@/plugins/snackbar";
import { mapState } from "vuex";

const DEFAULT_AUDIT_FORM = {
  item_list: [
    { first_class: "商家自营", second_class: "食品饮料", first_id: 304, second_id: 321 },
    { first_class: "商家自营", second_class: "B2b(商品批发/门店管理)", first_id: 304, second_id: 1553 },
  ],
  feedback_info: "",
  feedback_stuff: "",
  version_desc: "用于给品牌下合作的门店提交订单并完成线上支付。",
  preview_info: {},
  ugc_declare: {},
  privacy_api_not_use: true,
  order_path: "pages/mypage/order/index",
};



const DEFAULT_DOMAIN_CONFIG = {
  action: "set",
  requestdomain: [
    "https://api.yywd.vip",
    "https://api.yywding.cn",
    "https://cdn.yywding.cn",
    "https://obs.yywd.vip",
    "https://shop.api.yywd.vip",
    "https://api.v1.yywd.vip",
    "https://obs.yywding.cn",
  ],
  uploaddomain: [
    "https://api.yywd.vip",
    "https://api.yywding.cn",
    "https://cdn.yywding.cn",
    "https://obs.yywd.vip",
    "https://shop.api.yywd.vip",
    "https://api.v1.yywd.vip",
    "https://obs.yywding.cn",
  ],
  downloaddomain: [
    "https://api.yywd.vip",
    "https://api.yywding.cn",
    "https://cdn.yywding.cn",
    "https://obs.yywd.vip",
    "https://shop.api.yywd.vip",
    "https://api.v1.yywd.vip",
    "https://obs.yywding.cn",
  ],
};

const DEFAULT_PRIVACY_SET = {
  privacy_ver: 2,
  setting_list: [
    { privacy_key: "PhoneNumber", privacy_text: "登录绑定的门店账户", privacy_label: "" },
    { privacy_key: "Location", privacy_text: "定位门店信息", privacy_label: "" },
    { privacy_key: "Camera", privacy_text: "扫码或拍摄上传附件", privacy_label: "" },
    { privacy_key: "Album", privacy_text: "上传附件", privacy_label: "" },
    { privacy_key: "AlbumWriteOnly", privacy_text: "保存订单截图至相册", privacy_label: "" },
  ],
  owner_setting: {
    contact_email: "xieleijun@happklike.cn",
    notice_method: "弹窗公告",
  },
};

export default {
  components: {
    Breadcrumbs,
  },

  data: () => ({
    activeTab: 0,
    tabs: [
      { key: "code", label: "代码管理" },
      { key: "audit", label: "审核发布" },
      { key: "config", label: "配置设置" },
    ],
    appId: "",
    // 上传参数字段
    templateId: "",
    extAppid: "",
    accountId: "",
    showAccountId: false,
    defaultAccountId: "0210113",
    committing: false,
    // 二维码
    qrLoading: false,
    qrImageUrl: "",
    // 提交审核表单（单一 JSON 字符串）
    auditFormJson: "",
    auditSubmitting: false,
    // 查询审核
    auditQueryId: "",
    auditQueryLoading: false,
    latestAuditQueryLoading: false,
    auditQueryResult: "",
    // 发布
    releasing: false,
    releaseDialog: false,
    // Token
    tokenLoading: false,
    tokenResult: "",
    // 折叠状态
    auditExpanded: false,
    configExpanded: false,
    privacyExpanded: false,
    // JSON校验错误
    jsonErrors: { audit: "", domain: "", privacy: "" },
    // 费率设置
    rateForm: { sub_mchid: "", profit_rate: "" },
    rateSubmitting: false,
    // 域名配置
    domainJson: "",
    domainGetLoading: false,
    domainSetLoading: false,
    configQueryResult: "",
    // 隐私协议
    privacyJson: "",
    privacyGetLoading: false,
    privacySetLoading: false,
    privacyResult: "",
  }),

  computed: {
    items: () => [
      {
        text: "首页",
        disabled: false,
        href: "/home",
      },
      {
        text: "微信小程序B2B发布",
        disabled: true,
        href: "/wechat-b2b-deploy",
      },
    ],
    ...mapState(["accountInfo"]),
  },

  watch: {
    auditFormJson(val) { this.validateJson(val, 'audit'); },
    domainJson(val) { this.validateJson(val, 'domain'); },
    privacyJson(val) { this.validateJson(val, 'privacy'); },
  },

  mounted() {
    this.fetchAppId();
  },

  created() {
    this.auditFormJson = JSON.stringify(DEFAULT_AUDIT_FORM, null, 2);
    this.domainJson = JSON.stringify(DEFAULT_DOMAIN_CONFIG, null, 2);
    this.privacyJson = JSON.stringify(DEFAULT_PRIVACY_SET, null, 2);
  },

  beforeDestroy() {
    // 释放 blob URL 防止内存泄漏
    if (this.qrImageUrl) {
      URL.revokeObjectURL(this.qrImageUrl);
    }
  },

  methods: {
    // 从系统设置获取 wechat_mini_app_id
    fetchAppId() {
      Setting.getSettings({ keys: ["wechat_mini_app_id"] }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.appId = response.data.settings.wechat_mini_app_id || "";
            this.extAppid = this.appId;
            this.accountId = this.accountInfo ? this.accountInfo.account_id : "";
          }
        }.bind(this)
      );
    },

    // 上传代码并生成体验版
    handleCommit() {
      if (!this.appId) {
        snackbar.error("未获取到小程序 AppID，请检查系统设置");
        return;
      }
      const formData = {
        template_id: parseInt(this.templateId) || 0,
        ext: {
          extAppid: this.extAppid,
          ext: {
            accountId: this.accountId,
            showAccountId: this.showAccountId,
            defaultAccountId: this.defaultAccountId,
          },
        },
        app_id: this.appId,
      };

      this.committing = true;
      WechatB2b.commit(formData)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              snackbar.success("上传并提交成功");
            }
          }.bind(this)
        )
        .catch(() => {})
        .finally(() => {
          this.committing = false;
        });
    },

    // 获取体验版二维码
    fetchQRCode() {
      if (!this.appId) {
        snackbar.error("未获取到小程序 AppID，请检查系统设置");
        return;
      }

      this.qrLoading = true;
      WechatB2b.getTrialQRCodeImage({ app_id: this.appId })
        .then(
          function (response) {
            // 释放旧 blob URL
            if (this.qrImageUrl) {
              URL.revokeObjectURL(this.qrImageUrl);
            }
            const blob = new Blob([response.data], { type: "image/jpg" });
            this.qrImageUrl = URL.createObjectURL(blob);
          }.bind(this)
        )
        .catch(() => {
          snackbar.error("获取二维码失败，请重试");
        })
        .finally(() => {
          this.qrLoading = false;
        });
    },

    // 提交审核
    handleSubmitAudit() {
      if (!this.appId) {
        snackbar.error("未获取到小程序 AppID，请检查系统设置");
        return;
      }
      let formData;
      try {
        formData = JSON.parse(this.auditFormJson);
      } catch (e) {
        snackbar.error("JSON 格式有误，请检查");
        return;
      }
      formData.app_id = this.appId;

      this.auditSubmitting = true;
      WechatB2b.submitAudit(formData)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              snackbar.success("提交审核成功");
              const result = response.data.data;
              if (result && result.auditid) {
                this.auditQueryId = String(result.auditid);
              }
            }
          }.bind(this)
        )
        .catch(() => {})
        .finally(() => {
          this.auditSubmitting = false;
        });
    },

    // 查询指定审核单状态
    handleGetAuditStatus() {
      if (!this.appId) {
        snackbar.error("未获取到小程序 AppID，请检查系统设置");
        return;
      }
      if (!this.auditQueryId) {
        snackbar.error("请输入审核单 ID");
        return;
      }
      this.auditQueryLoading = true;
      this.auditQueryResult = "";
      WechatB2b.getAuditStatus({
        app_id: this.appId,
        auditid: this.auditQueryId,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.auditQueryResult = JSON.stringify(
                response.data.data,
                null,
                2
              );
            }
          }.bind(this)
        )
        .catch(() => {})
        .finally(() => {
          this.auditQueryLoading = false;
        });
    },

    // 查询最新审核单状态
    handleGetLatestAuditStatus() {
      if (!this.appId) {
        snackbar.error("未获取到小程序 AppID，请检查系统设置");
        return;
      }
      this.latestAuditQueryLoading = true;
      this.auditQueryResult = "";
      WechatB2b.getLatestAuditStatus({ app_id: this.appId })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.auditQueryResult = JSON.stringify(
                response.data.data,
                null,
                2
              );
            }
          }.bind(this)
        )
        .catch(() => {})
        .finally(() => {
          this.latestAuditQueryLoading = false;
        });
    },

    // 发布小程序
    handleRelease() {
      if (!this.appId) {
        snackbar.error("未获取到小程序 AppID，请检查系统设置");
        return;
      }
      this.releasing = true;
      WechatB2b.release({ app_id: this.appId })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              snackbar.success("发布成功");
              this.releaseDialog = false;
            }
          }.bind(this)
        )
        .catch(() => {})
        .finally(() => {
          this.releasing = false;
        });
    },

    // JSON格式校验
    validateJson(value, field) {
      if (!value || !value.trim()) {
        this.$set(this.jsonErrors, field, '');
        return true;
      }
      try {
        JSON.parse(value);
        this.$set(this.jsonErrors, field, '');
        return true;
      } catch (e) {
        this.$set(this.jsonErrors, field, 'JSON 格式有误');
        return false;
      }
    },

    // 获取B2b AccessToken
    handleGetToken() {
      if (!this.appId) { snackbar.error("未获取到小程序 AppID"); return; }
      this.tokenLoading = true;
      this.tokenResult = "";
      WechatB2b.getB2bAccessToken({ app_id: this.appId })
        .then(function (response) {
          if (response.data.status.isOK()) {
            const data = response.data.data;
            this.tokenResult = typeof data === 'object' ? (data.data || JSON.stringify(data)) : String(data);
          }
        }.bind(this))
        .catch(() => {})
        .finally(() => { this.tokenLoading = false; });
    },

    // 复制Token到剪贴板
    copyToken() {
      if (!this.tokenResult) return;
      const el = document.createElement('textarea');
      el.value = this.tokenResult;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      snackbar.success('Token 已复制到剪贴板');
    },

    // 申请费率
    handleSetRate() {
      if (!this.appId) { snackbar.error("未获取到小程序 AppID"); return; }
      if (!this.rateForm.sub_mchid) { snackbar.error("请输入子商户号"); return; }
      if (!this.rateForm.profit_rate && this.rateForm.profit_rate !== 0) {
        snackbar.error("请输入费率"); return;
      }
      this.rateSubmitting = true;
      WechatB2b.setmchprofitrate({
        app_id: this.appId,
        sub_mchid: this.rateForm.sub_mchid,
        profit_rate: parseInt(this.rateForm.profit_rate),
      })
        .then(function (response) {
          if (response.data.status.isOK()) snackbar.success("费率申请提交成功");
        }.bind(this))
        .catch(() => {})
        .finally(() => { this.rateSubmitting = false; });
    },

    // 获取当前域名
    handleGetDomain() {
      if (!this.appId) { snackbar.error("未获取到小程序 AppID"); return; }
      this.domainGetLoading = true;
      this.configQueryResult = "";
      WechatB2b.modifyDomain({ app_id: this.appId, modify_domain: { action: "get" } })
        .then(function (response) {
          if (response.data.status.isOK()) {
            this.configQueryResult = JSON.stringify(response.data.data, null, 2);
          }
        }.bind(this))
        .catch(() => {})
        .finally(() => { this.domainGetLoading = false; });
    },

    // 配置域名
    handleSetDomain() {
      if (!this.appId) { snackbar.error("未获取到小程序 AppID"); return; }
      let domainData;
      try { domainData = JSON.parse(this.domainJson); }
      catch (e) { snackbar.error("域名 JSON 格式有误，请检查"); return; }
      this.domainSetLoading = true;
      this.configQueryResult = "";
      WechatB2b.modifyDomain({ app_id: this.appId, modify_domain: domainData })
        .then(function (response) {
          if (response.data.status.isOK()) {
            snackbar.success("域名配置成功");
            this.configQueryResult = JSON.stringify(response.data.data, null, 2);
          }
        }.bind(this))
        .catch(() => {})
        .finally(() => { this.domainSetLoading = false; });
    },

    // 获取隐私协议
    handleGetPrivacy() {
      if (!this.appId) { snackbar.error("未获取到小程序 AppID"); return; }
      let privacyData;
      try { privacyData = JSON.parse(this.privacyJson); }
      catch (e) { snackbar.error("隐私 JSON 格式有误，请检查"); return; }
      this.privacyGetLoading = true;
      this.privacyResult = "";
      WechatB2b.getPrivacySetting({
        app_id: this.appId,
        privacy_ver: privacyData.privacy_ver || 2,
      })
        .then(function (response) {
          if (response.data.status.isOK()) {
            this.privacyResult = JSON.stringify(response.data.data, null, 2);
          }
        }.bind(this))
        .catch(() => {})
        .finally(() => { this.privacyGetLoading = false; });
    },

    // 设置隐私协议
    handleSetPrivacy() {
      if (!this.appId) { snackbar.error("未获取到小程序 AppID"); return; }
      let privacyData;
      try { privacyData = JSON.parse(this.privacyJson); }
      catch (e) { snackbar.error("隐私 JSON 格式有误，请检查"); return; }
      privacyData.app_id = this.appId;
      this.privacySetLoading = true;
      this.privacyResult = "";
      WechatB2b.setPrivacySetting(privacyData)
        .then(function (response) {
          if (response.data.status.isOK()) {
            snackbar.success("隐私协议设置成功");
            this.privacyResult = JSON.stringify(response.data.data, null, 2);
          }
        }.bind(this))
        .catch(() => {})
        .finally(() => { this.privacySetLoading = false; });
    },
  },
};
</script>
